import {Answer} from "./types/types";

export function findAnswer (answers: Answer[], key: string) : Answer {
	return answers.find(x => x.key === key) || {
		name: '???',
		meta: '???',
		key: '???',
	}
}
